/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import stepsApi from '@/services/steps-api';

const state = {
  steps: null,
  stepsHistory: null,
  participantPositionData: null,
  participantAndNeighbors: null,
  periodSteps: null,
  responseStatus: null,
  ratings: null,
};

const mutations = {
  setSteps(state, value) {
    state.steps = value;
  },
  setStepsHistory(state, value) {
    state.stepsHistory = value;
  },
  setResponseStatus(state, value) {
    state.responseStatus = value;
  },
  setParticipantPositionData(state, value) {
    state.participantPositionData = value;
  },
  setPeriodSteps(state, value) {
    state.periodSteps = value;
  },
  setParticipantAndNeighbors(state, value) {
    state.participantAndNeighbors = value;
  },
  setRatings(state, value) {
    state.ratings = value;
  },
};

const getters = {
  steps: (state) => state.steps,
  stepsHistory: (state) => state.stepsHistory,
  responseStatus: (state) => state.responseStatus,
  participantPositionData: (state) => state.participantPositionData,
  periodSteps: (state) => state.periodSteps,
  participantAndNeighbors: (state) => state.participantAndNeighbors,
  ratings: (state) => state.ratings,
};

const actions = {
  getSteps({ commit }) {
    return stepsApi.getSteps()
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setSteps', response.data);
        } else {
          commit('setSteps', null);
        }
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getStepsHistory({ commit }, { dateFrom, dateTo, periodType }) {
    return stepsApi.getStepsHistory({ dateFrom, dateTo, periodType })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setStepsHistory', response.data);
          return response.data;
        }
        commit('setStepsHistory', null);
        return null;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  setTargetSteps({ commit }, { targetCount }) {
    return stepsApi.setTargetSteps({ targetCount })
      .then((response) => {
        commit('setResponseStatus', response.status);
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getParticipantPositionData({ commit }, { dateFrom, dateTo, periodType }) {
    return stepsApi.getParticipantPosition({ dateFrom, dateTo, periodType })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setParticipantPositionData', response.data);
          return response.data;
        }
        commit('setParticipantPositionData', null);
        return null;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getPeriodSteps({ commit }, { dateFrom, dateTo, periodType }) {
    return stepsApi.getPeriodSteps({ dateFrom, dateTo, periodType })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setPeriodSteps', response.data);
          return response.data;
        }
        commit('setPeriodSteps', null);
        return null;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getParticipantAndNeighbors({ commit }, { dateFrom, dateTo, periodType }) {
    return stepsApi.getParticipantAndNeighbors({ dateFrom, dateTo, periodType })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setParticipantAndNeighbors', response.data);
          return response.data;
        }
        commit('setParticipantAndNeighbors', null);
        return null;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
  getRatings({ commit }, {
    dateFrom, dateTo, periodType, offset, count,
  }) {
    return stepsApi.getRatings({
      dateFrom, dateTo, periodType, offset, count,
    })
      .then((response) => {
        commit('setResponseStatus', response.status);
        if (response.status === 200) {
          commit('setRatings', response.data);
          return response.data;
        }
        commit('setRatings', null);
        return null;
      })
      .catch((error) => {
        const status = error.response && error.response.status;
        commit('setResponseStatus', status || 0);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
